export default __webpack_public_path__ + "758a8b8e673d2f8cbcb81df20bb12c72.png";